export default __webpack_public_path__ + "images/cocktail-icon.png";